if (!customElements.get('lusso-ticker')) {
  customElements.define(
    'lusso-ticker',
    class LussoTicker extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-ticker-slide]')];
        this.previousButton = this.querySelector('[data-ticker-previous]');
        this.nextButton = this.querySelector('[data-ticker-next]');
        this.toggleButton = this.querySelector('[data-ticker-toggle]');
        this.pauseIcon = this.querySelector('[data-ticker-pause-icon]');
        this.playIcon = this.querySelector('[data-ticker-play-icon]');
        this.status = this.querySelector('[data-ticker-status]');
        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
        );
        this.interval = Number(this.dataset.interval) || 6000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.userPaused = false;
        this.temporarilyPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handlePrevious = () => this.show(this.index - 1, true);
        this.handleNext = () => this.show(this.index + 1, true);
        this.handleToggle = () => this.setUserPaused(!this.userPaused);
        this.handleFocusIn = () => this.setTemporaryPause(true);
        this.handleFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.setTemporaryPause(false);
        };
        this.handlePointerEnter = () => this.setTemporaryPause(true);
        this.handlePointerLeave = () => this.setTemporaryPause(false);
        this.handleVisibility = () => this.syncTimer();
        this.handleMotionPreference = () => this.syncTimer();

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.toggleButton?.addEventListener('click', this.handleToggle);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        this.addEventListener('pointerenter', this.handlePointerEnter);
        this.addEventListener('pointerleave', this.handlePointerLeave);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.reducedMotion.addEventListener?.('change', this.handleMotionPreference);

        this.show(this.index, false);
        this.syncTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.toggleButton?.removeEventListener('click', this.handleToggle);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.removeEventListener('pointerenter', this.handlePointerEnter);
        this.removeEventListener('pointerleave', this.handlePointerLeave);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.reducedMotion?.removeEventListener?.('change', this.handleMotionPreference);
      }

      show(nextIndex, announce = false) {
        if (this.slides.length < 1) return;

        this.index = (nextIndex + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });

        if (announce && this.status) {
          this.status.textContent = `Announcement ${this.index + 1} of ${this.slides.length}`;
        }

        this.syncTimer();
      }

      setUserPaused(paused) {
        this.userPaused = paused;
        this.toggleButton?.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
        if (this.pauseIcon) this.pauseIcon.hidden = paused;
        if (this.playIcon) this.playIcon.hidden = !paused;
        this.syncTimer();
      }

      setTemporaryPause(paused) {
        this.temporarilyPaused = paused;
        this.syncTimer();
      }

      syncTimer() {
        this.stopTimer();

        if (
          !this.autoplay ||
          this.userPaused ||
          this.temporarilyPaused ||
          this.reducedMotion.matches ||
          document.hidden ||
          this.slides.length < 2
        ) {
          return;
        }

        this.timer = window.setTimeout(() => this.show(this.index + 1), this.interval);
      }

      stopTimer() {
        if (!this.timer) return;
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    },
  );
}
